/**
 * The card currently being dragged. dataTransfer can't be read during
 * dragover, so columns use this to compute the drop slot (excluding the card
 * itself) while hovering.
 */
export const dragState = { taskId: null };
